<script setup lang="ts">
import { RouterView } from 'vue-router'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import AppHeader from '@/components/app/AppHeader.vue'
import ProjectSideBar from '@/components/project-detail/ProjectSideBar.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'
import { useDjangoAuthStore } from '@/stores/authDjango'
import LoadingNotice from '@/components/app/LoadingNotice.vue'
import { PROJECT_SCOPED_ROUTE_NAMES } from '@/router/routeNames'

const route = useRoute()
const { isInitDone } = storeToRefs(useDjangoAuthStore())

const isProjectSideBarShown = computed(
  () =>
    typeof route.name === 'string' &&
    PROJECT_SCOPED_ROUTE_NAMES.includes(
      route.name as (typeof PROJECT_SCOPED_ROUTE_NAMES)[number]
    ) &&
    Boolean(route.params.id)
)
</script>

<template>
  <v-app>
    <template v-if="isInitDone">
      <AppHeader />
      <ProjectSideBar v-if="isProjectSideBarShown" />
      <v-main>
        <RouterView />
      </v-main>
      <OptionsSnackbar
        style="z-index: 3000"
        :excluded-http-methods="['GET', 'OPTIONS', 'DOWNLOAD_BLOB', 'DOWNLOAD_BLOB_WITH_BODY']"
      ></OptionsSnackbar>
    </template>
    <LoadingNotice v-else app-name="CloudCompute" />
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
